import * as React from 'react';
/* eslint-disable react-hooks/exhaustive-deps */
// A semantic wrapper around useEffect for the case to only call on unmount
// functions returned from useEffect are called on unmount
export function useWillUnmountEffect(callback: React.EffectCallback) {
  const memoCallback = React.useCallback(callback, []);
  React.useEffect(() => {
    return () => {
      memoCallback();
    };
  }, [memoCallback]);
}
